import {useApp} from '../../../contexts/AppContext';
import {useAuth} from '../../../contexts/UserContext';
import {useEffect, useState, useRef, useMemo} from 'react';
import styled from 'styled-components';
import config from '../../../config';
import {Link} from 'react-router-dom';
import moment from 'moment';
import {PageMainTitle} from '../../atoms/CommonParts';
import {getVenueChart} from '../../../api';
import LabelWithInfo from '../../atoms/LabelWithInfo';
import SelectModal, {SelectedLabel} from '../../organisms/SelectModal';
import SimpleBar from 'simplebar-react';

const Page = styled.div`
  @media ${config.layout.wide} {
  }
`;

const CHART_MONTHS = [];
const oldestChartMonth = 'JUN 2024';
const tempM = moment();
tempM.date(15);
do {
  let label = tempM.format('MMM YYYY').toUpperCase();
  CHART_MONTHS.push({
    label,
    year: tempM.year(),
    month: tempM.month() + 1,
  });
  if (label === oldestChartMonth) {
    break;
  }
  tempM.add(-1, 'months');
} while (1);
const PoweredBy = styled.div`
  position: absolute;
  right: 0;
  bottom: 20px;
  display: flex;
  align-items: flex-end;

  .label {
    font-size: 10px;
    font-weight: bold;
    margin-right: 8px;
    position: relative;
    top: -1px;
  }

  a {
    display: block;
    width: 51.751px;
    height: 32.307px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGgAAABBCAMAAAAKYRFtAAAAe1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC9eBywAAAAKHRSTlMAgEDA8BCgvzBgcFAg0OCwkN+vjxrquTUL85YmymZTO/zZqaJ3SSmKtEEFjgAAA5xJREFUWMPtmNd23CAQQAcEGAFqu+te0hP+/wujGYpkyy0+ozzk5D74iEXiomEoMvwRuv16N6l4/uXuxl/Bbvxo4prDT9gFmzULn80J+PkeM9eH7/cP8uFeXFzH6x/snpusuZGw8MlEx+y5SJpvIYdRSgvI6Tiyeo6kOb/Ea29Usirj0dkyetqIdDj0LluySwAntxG5uALwU3zC5BlFA7b4Zfa4uIUxHS4pqQOAqRFrZvpSMqwZ5wFEtowWCDvm8WJKPI1tDZQRdBWgEoZI8CTePTZ1C1ptR6TYleZKhW8A4vm+t3zBO58buoTw0riPVBEYRLgkALglRGGKZmlYU/YxTNyAKylAtwRuoJb1o+B1PLPoIUcuNd6kJaEtr8QUu59zK59AphwvIuJMrhYOyTKNblN8RBEVjlQWTIP0GUMmNiJi4BR1r4gUZQOT6BeG7gXRyPlGsibDuIjW297IJAIV2ySaHouMBmJiyToKjUHbjF2JmtK0pSIwcHXeA5i61NFlv6yuJqUfBy5ego81QHpohIaCZdyR4OIrQE+jpDfzmUaoBx6u7k4gI9LpJ56O7YWIkyk50FlYYZOnAzZOMm886w1CCxUTGjixpdlDK62V7SFWWuA2beGN3TL0LxCAmfbJS6khDxxwo8XqrXqhIVBGTLADwY3NjHE2u12f14z9aRsDfwkL/9kfr5THKWk+/HSY3jWfBO6T8mO7Mj0t5oeb993aQPjoJuZidG+JrDgj6LYgdXrQ4E/C5lrjcoSOWDp6IFpDJZqsUmI41FykOXygx0NeTQ5ndr18LaJQ1xlTF2h8aCilAz5/tj6DW4siZL6eylLYYhdQIMBWDYUuLVvN81vBuJRGtFZEDh2i8BxRkfnj12GbvZgZSUTJQH8N/tjHXIsv5jXegiXsh8YeDljqsHFKBrrZojSOWDMrBqxRotUwF1LEzSISZVTlcmpMDan6KSNbfMlSsuusM+X07DE+Tf6Ur8dZ8Ugk6gfsNn1JK2tvqIlSXzpV+0n3/psiVUQjRvYt0QSEekmkno5RT6Ks77yU0mEOvi7SOIHkzAGzbisKVB8oz9r5Nvzv3lBFMlaUfl0EJlYMbES5XuHMqcgqgrF6LLwhWo5bnd6Iaj2AryYHiwjkgPWNCVBEvu89EEP68ik/adfMbfSN03juLh9JoxqWejo9BNNgbwY0CNWFZxdhBXvj00ozwN6kwKoAe9OTR8LOUOiE07ATvwH46sW1RBn5hgAAAABJRU5ErkJggg==');

`;

const PeriodWrap = styled.div`
  position: relative;
`;

const PeriodContents = styled.div`
  padding-top: calc(37px + 56px);
  @media ${config.layout.wide} {
    padding-top: calc(37px + 44px);
  }
`;

const LatestChartElm = styled.div`
  min-height: 160px;
  border-radius: 2px;
  border: 1px solid #000000;
  position: relative;
  @media ${config.layout.wide} {
    border-radius: 2px 0 2px 2px;
  }
`;

const LatestChartRoomSelectorWrap = styled.div`
  overflow-x: scroll;
  @media ${config.layout.wide} {
    overflow-x: hidden;
    position: relative;
    height: 44px;
  }
`;

const LatestChartRoomSelectorItems = styled.div`
  display: flex;
  height: 44px;
  align-items: center;
  gap: 1px;

  @media ${config.layout.wide} {
    position: absolute;
    transition: left 0.15s ease-out;
  }
`;

const LatestChartRoomSelectorItem = styled.div`
  min-width: 80px;
  height: 44px;
  text-align: center;
  line-height: 44px;
  font-size: 14px;
  color: #ffffff;
  background-color: #000000;
  font-weight: bold;
  
  cursor: pointer;
  white-space: nowrap;
  padding: 0 20px;
  flex: 0 0 auto;

  &.active {
    color: #000000;
    background-color: transparent;
  }

  &.in_touch {
    color: #000000;
    background-color: #ffffff;
  }
  
  @media ${config.layout.wide} {
    transition: background-color 0.15s linear, color 0.15s linear;
    @media (hover: hover) {
      &:hover {
        color: #000000;
        background-color: #ffffff;
      }
    }
  }
`;

const LatestChartRoomSelectorControls = styled.div`
  position: absolute;
  right: -40px;
  top: -1px;
  display: none;
  @media ${config.layout.wide} {
    display: block;
  }
`;

const LatestChartRoomSelectorControl = styled.button`
  display: block;
  width: 40px;
  height: 30px;
  border-radius: 0;
  background-color: #000000;
  margin-bottom: 1px;
  position: relative;

  &:before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-repeat: no-repeat;
    background-position: center;

    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path  d="M4.445,5,0,.744.777,0,6,5,.777,10,0,9.256Z" fill="%23fff"/></svg>');
  }

  &.prev {
    &:before {
      transform: rotateZ(180deg);
    }
  }

  &.disabled {
    opacity: 0.1;
    cursor: default;
  }


  &:not(.disabled) {
    &.in_touch {
      background-color: #fff;

      &:before {
        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path  d="M4.445,5,0,.744.777,0,6,5,.777,10,0,9.256Z" fill="%23000"/></svg>');
      }
    }

    @media (hover: hover) {
      &:hover {
        background-color: #fff;

        &:before {
          background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path  d="M4.445,5,0,.744.777,0,6,5,.777,10,0,9.256Z" fill="%23000"/></svg>');
        }
      }
    }
  }
`;

function LatestChartRoomSelector({
  selectedRoomID,
  rooms,
  onRoomSelected,
}) {
  const updateScrollTimerRef = useRef(null);
  const wrapRef = useRef();
  const itemsRef = useRef();
  const [detached, setDetached] = useState(false);

  useEffect(() => {
    let cb = () => {
      updatePos();
    };
    window.addEventListener('resize', cb);
    cb();
    return () => {
      //setDetached(true);
      window.removeEventListener('resize', cb);
    };
  }, []);

  useEffect(() => {
    updatePos();
  }, [selectedRoomID, rooms]);

  const updatePos = () => {
    if (detached) {
      return;
    }
    if (updateScrollTimerRef.current) {
      clearTimeout(updateScrollTimerRef.current);
      updateScrollTimerRef.current = null;
    }
    updateScrollTimerRef.current = setTimeout(() => {
      if (detached) {
        return;
      }
      updatePosCore();
    }, 100);
  };

  const updatePosCore = () => {
    if (detached ||
        !wrapRef.current ||
        window.isSP() ||
        !itemsRef.current
    ) {
      if (itemsRef.current) {
        itemsRef.current.style.left = '0px';
      }
      return;
    }
    if (updateScrollTimerRef.current) {
      clearTimeout(updateScrollTimerRef.current);
      updateScrollTimerRef.current = null;
    }

    let wrapWidth = wrapRef.current.clientWidth;
    let currentLeft = parseInt(itemsRef.current.style.left || '0', 10);
    let tabs = [...itemsRef.current.children];

    const {left, right} = tabs.reduce((p, c, i) => {
      let id = parseInt(c.getAttribute('data-id'), 10);
      if (p.found) {
        return p;
      }
      if (id === selectedRoomID) {
        p.right = p.left + c.clientWidth;
        p.found = true;
        return p;
      }
      p.left += c.clientWidth + 1;
      return p;
    }, {left: 0, right: 0, found: false});
    if (!left && !right) {
      return;
    }
    if (currentLeft + left < 0) {
      itemsRef.current.style.left = `${-1 * left}px`;
    } else if (currentLeft + right > wrapWidth) {
      itemsRef.current.style.left = `${-1 * (right - wrapWidth)}px`;
    }
  };

  const currentPos = useMemo(() => {
    return Math.min(Math.max(0,
        rooms.findIndex(r => r.id === selectedRoomID)), rooms.length - 1);
  }, [selectedRoomID, rooms]);

  const onNextClicked = () => {
    if (currentPos < (rooms.length - 1)) {
      onRoomSelected(rooms[currentPos + 1].id);
    }
  };

  const onPrevClicked = () => {
    if (currentPos > 0) {
      onRoomSelected(rooms[currentPos - 1].id);
    }
  };

  return (
      <>
        <LatestChartRoomSelectorControls>
          <LatestChartRoomSelectorControl
              className={`in_touch_target next ${currentPos < rooms.length - 1
                  ? ''
                  : 'disabled'}`}
              onClick={onNextClicked}/>
          <LatestChartRoomSelectorControl
              className={`in_touch_target prev ${currentPos === 0 ? 'disabled' : ''}`}
              onClick={onPrevClicked}/>
        </LatestChartRoomSelectorControls>
        <LatestChartRoomSelectorWrap ref={wrapRef}>
          <LatestChartRoomSelectorItems ref={itemsRef}>
            {
              rooms.map((r, i) => {
                return (
                    <LatestChartRoomSelectorItem key={i}
                                                 data-id={r.id}
                                                 className={`in_touch_target ${r.id ===
                                                 selectedRoomID
                                                     ? 'active'
                                                     : ''} item-${r.id}}`}
                                                 onClick={() => {
                                                   onRoomSelected(r.id);
                                                 }}
                    >{r.name}</LatestChartRoomSelectorItem>
                );
              })
            }
          </LatestChartRoomSelectorItems>
        </LatestChartRoomSelectorWrap>
      </>
  );
}

const NoData = styled.div`
  border: 1px solid #000000;
  border-radius: 2px;
  height: 166px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:before {
    content: 'No data available';
    font-weight: bold;
    font-size: 20px;
  }
`;

const PeriodSectionWrap = styled.div`
  padding-bottom: 40px;
`;

const ChartHeader = styled.div`
  margin-top: 10px;
  margin-bottom: 30px;
  @media ${config.layout.wide} {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20px;
  }
`;

const CurrentPeriodArea = styled.div`
  @media ${config.layout.wide} {
    width: calc(50% - 10px);
    flex: 0 0 auto;
  }

`;

const CurrentPeriod = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;

  .to {
    width: 26px;
    height: 2px;
    background-color: #000;
  }

  span {
    font-size: 20px;
    font-weight: bold;
    line-height: 26px;
    color: #000000;
  }
`;

const PER_PAGE_OPTIONS = [
  10,
  25,
  50,
];

const SORT_OPTIONS = [
  {
    label: 'Default',
    sort_by: 'default',
    sort_order: 'asc',
  },
  {
    label: 'BPM High to Low',
    sort_by: 'bpm',
    sort_order: 'desc',
  },
  {
    label: 'BPM Low to High',
    sort_by: 'bpm',
    sort_order: 'asc',
  },
];

const ViewConfigItems = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
`;

const ViewConfigItem = styled.div`
  width: calc((100% - 18px) / 3);
  flex: 0 0 auto;
`;

const ViewConfigSelectModalButton = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #000000;
  border-radius: 2px;
  height: 44px;
  cursor: default;
  position: relative;
  color: #000;

  @media ${config.layout.wide} {
    transition: background-color 0.15s linear, color 0.15s linear;
    height: 44px;
    font-size: 16px;
    line-height: 21px;
  }

  &::after {
    content: "";
    position: absolute;
    display: block;
    width: 9px;
    height: 8px;
    border-top: 2px solid #000;
    border-bottom: 2px solid #000;
    right: 14px;
    top: 50%;
    margin-top: -4px;

    @media ${config.layout.wide} {
      right: 15px;
    }
  }

  span {
    font-size: 12px;
    line-height: 1;
    margin-right: 19px;
    text-align: center;
    font-weight: bold;

    @media ${config.layout.wide} {
      margin-right: 20px;
    }
  }

  &.in_touch {
    background-color: #000;
    color: #fff;

    &::after {
      border-color: #fff;
    }
  }

  @media ${config.layout.wide} {
    @media (hover: hover) {
      &:hover {
        background-color: #000;
        color: #fff;

        &::after {
          border-color: #fff;
        }
      }
    }
  }
`;

const ViewConfigResetButton = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #000000;
  border-radius: 2px;
  height: 44px;
  cursor: default;
  position: relative;
  color: #000;
  

  @media ${config.layout.wide} {
    transition: background-color 0.15s linear, color 0.15s linear;
    height: 44px;
    font-size: 16px;
    line-height: 21px;
  }

  span {
    font-size: 12px;
    line-height: 1;
    text-align: center;
    font-weight: bold;
  }

  &.in_touch {
    background-color: #000;
    color: #fff;
  }
  
  @media ${config.layout.wide} {
    @media (hover: hover) {
      &:hover {
        background-color: #000;
        color: #fff;
      }
    }
  }
`;

function CharListViewConfig({onRoomSelected}) {
  const {state, dispatch} = useApp();

  const [perPageModalIsOpen, setPerPageModalIsOpen] = useState(false);
  let selectedPerPageIndex = PER_PAGE_OPTIONS.findIndex(
      v => state.chart_view.per_page === v);

  const [sortModalIsOpen, setSortModalIsOpen] = useState(false);
  let selectedSortIndex = SORT_OPTIONS.findIndex(
      v => state.chart_view.sort_by === v.sort_by &&
          state.chart_view.sort_order === v.sort_order);

  const onPerPageClick = () => {
    setPerPageModalIsOpen(true);
  };

  const closePerPageModal = () => {
    setPerPageModalIsOpen(false);
  };

  const itemPerPageSelect = (index) => {
    setPerPageModalIsOpen(false);
    dispatch({
      type: 'set_chart_view',
      chart_view: {
        ...state.chart_view,
        per_page: PER_PAGE_OPTIONS[index],
      },
    });
  };

  const onSortClick = () => {
    setSortModalIsOpen(true);
  };

  const closeSortModal = () => {
    setSortModalIsOpen(false);
  };

  const itemSortSelect = (index) => {
    setSortModalIsOpen(false);
    dispatch({
      type: 'set_chart_view',
      chart_view: {
        ...state.chart_view,
        sort_by: SORT_OPTIONS[index].sort_by,
        sort_order: SORT_OPTIONS[index].sort_order,
      },
    });
  };

  return (
      <ViewConfigItems>
        <ViewConfigItem>
          <ViewConfigSelectModalButton onClick={onPerPageClick}
                                       className="in_touch_target"
          ><span>Per Page</span></ViewConfigSelectModalButton>
          <SelectModal
              title="Per Page"
              candidates={PER_PAGE_OPTIONS}
              selectedIndex={selectedPerPageIndex}
              closeModal={closePerPageModal}
              modalIsOpen={perPageModalIsOpen}
              itemSelect={itemPerPageSelect}
          />
        </ViewConfigItem>
        <ViewConfigItem>
          <ViewConfigSelectModalButton onClick={onSortClick}
                                       className="in_touch_target"
          ><span>Sort by</span></ViewConfigSelectModalButton>
          <SelectModal
              title="Sort by"
              candidates={SORT_OPTIONS.map(v => v.label)}
              selectedIndex={selectedSortIndex}
              closeModal={closeSortModal}
              modalIsOpen={sortModalIsOpen}
              itemSelect={itemSortSelect}
          />
        </ViewConfigItem>
        <ViewConfigItem>
          <ViewConfigResetButton
              className="in_touch_target"
              onClick={() => {
            onRoomSelected(0);
            dispatch({
              type: 'set_chart_view',
              chart_view: {
                per_page: 10,
                sort_by: 'default',
                sort_order: 'asc',
              },
            });
          }}><span>Reset</span></ViewConfigResetButton>
        </ViewConfigItem>
      </ViewConfigItems>
  );
}

const ChartListHeaderWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 16px;
  gap: 20px;
  @media ${config.layout.wide} {
    height: 80px;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    margin: 0 20px 20px;
  }
`;

const ChartListTitleWrap = styled.div`
  @media ${config.layout.wide} {
    width: calc(50% - 10px);
    flex: 0 0 auto;
  }
`;

const ChartListTitle = styled.div`
  font-size: 26px;
  line-height: 34px;
  font-weight: bold;
`;

const ChartListSortCondition = styled.div`
  font-size: 16px;
  line-height: 21px;
  font-weight: bold;
  margin-top: 10px;

  &:empty {
    display: none;
  }

  @media ${config.layout.wide} {
    margin-top: 5px;
    &:empty {
      display: block;
      margin-top: 7px;
    }
  }
`;

const CharListViewConfigWrap = styled.div`
  @media ${config.layout.wide} {
    width: calc(50% - 10px);
    flex: 0 0 auto;
  }
`;

const ChartListWrap = styled.div`
`;

const ChartListFooter = styled.div`
  height: 124px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;

  &.hidden {
    height: 16px;

    & > * {
      display: none;
    }
  }
`;

const ChartListNavButton = styled.div`
  cursor: pointer;
  width: 20px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 0 0 auto;

  &.next {
    justify-content: flex-end;
  }

  &.hidden {
    visibility: hidden;
    pointer-events: none;
  }

  user-select: none;
`;

const ChartListPageButtons = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 20px;
`;

const ChartListPageButton = styled.div`
  cursor: pointer;
  width: 44px;
  height: 44px;
  border: 1px solid #000;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000;
  color: #fff;
  user-select: none;

  @media ${config.layout.wide} {
    transition: background-color 0.15s linear, color 0.15s linear;
  }
  
  span {
    font-weight: bold;
    font-size: 14px;
  }

  &.active {
    background-color: transparent;
    color: #000;
  }

  &.pc {
    @media ${config.layout.wide} {
      display: flex !important;
    }
  }
  
  &.in_touch {
    background-color: transparent;
    color: #000;
  }

  &:hover {
    @media ${config.layout.wide} {
      @media (hover: hover) {
        background-color: transparent;
        color: #000;
      }
    }
  }
`;

const ChartListPageEllipsis = styled.div`
  pointer-events: none;
  font-weight: bold;
  font-size: 20px;
  line-height: 26px;
`;

const ChartListContentWrap = styled.div`
  margin: 0 16px;
`;

const ChartListContentItems = styled.div`
  border: 1px solid #000;
`;

const ChartListContentItem = styled.div`
  border-bottom: 1px solid #000;

  display: flex;
  align-items: stretch;

  &:last-child {
    border-bottom: none;
  }
`;

const ChartListContentRankArea = styled.div`
  width: 38px;
  border-right: 1px solid #D6D6D6;
  background-color: #F8F8F8;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;
  flex: 0 0 auto;

  & > div {
    display: flex;
    gap: 2px;
    flex-direction: column;

    .label {
      font-size: 10px;
      line-height: 13px;
    }

    .rank {
      font-weight: bold;
      font-size: 16px;
      line-height: 21px;
    }
  }
`;

const ChartListContentBodyArea = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  @media ${config.layout.wide} {
    flex-direction: row;
  }
`;

const ChartListContentTitles = styled.div`
  border-bottom: 1px solid #D6D6D6;
  padding: 0 12px 10px 9px;

  @media ${config.layout.wide} {
    border-bottom: none;
    border-right: 1px solid #D6D6D6;
    flex: 1 1 auto;

  }

  & > div {
    margin-top: 10px;

    .label {
      font-size: 10px;
      line-height: 13px;
    }

    .value {
      margin-top: 3px;
      font-weight: bold;
      font-size: 14px;
      line-height: 19px;
      @media ${config.layout.wide} {
        max-width: 545px;
      }
    }
  }
`;

const ChartListContentMetadata = styled.div`
  display: flex;
  align-items: center;
  height: 57px;

  @media ${config.layout.wide} {
    width: 85px;
    height: unset;
    flex: 0 0 auto;
    flex-direction: column;
    align-items: flex-start;
  }

  & > div {
    width: calc(100% / 3);
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media ${config.layout.wide} {
      width: unset;
      align-items: flex-start;
      margin-top: 10px;
      margin-left: 9px;
      &:last-child {
        margin-bottom: 10px;
      }
    }

    .label {
      font-size: 10px;
      line-height: 13px;
    }

    .value {
      margin-top: 3px;
      font-weight: bold;
      font-size: 16px;
      line-height: 21px;

      &:empty {
        &:before {
          content: ' ';
        }
      }
    }
  }

`;

function ChartListContent({tracks}) {

  useEffect(() => {
    const elm = document.querySelector('#period-selector');
    console.log(elm.classList);
    if (elm && elm.classList.contains('is-pinned')) {
      document.querySelector('#period-wrap').scrollIntoView(true);
    }
  }, [tracks]);

  return (
      <ChartListContentWrap>
        <ChartListContentItems>
          {
            tracks.map((t, i) => {
              return (
                  <ChartListContentItem
                      key={i}>
                    <ChartListContentRankArea>
                      <div>
                        <div className={'label'}>No.</div>
                        <div className={'rank'}>{`${t.rank}`.padStart(2,
                            '0')}</div>
                      </div>
                    </ChartListContentRankArea>
                    <ChartListContentBodyArea>
                      <ChartListContentTitles>
                        <div>
                          <div className={'label'}>Title</div>
                          <div className={'title value'}>{t.title}</div>
                        </div>
                        <div>
                          <div className={'label'}>Artist</div>
                          {
                            t.artist ? (
                                <div className={'artist value'}>{t.artist}</div>
                            ) : (
                                <div className={'artist value'}>&nbsp;</div>
                            )
                          }
                        </div>
                        <div>
                          <div className={'label'}>Label</div>
                          {
                            t.record_label ? (
                                <div
                                    className={'record_label value'}>{t.record_label}</div>
                            ) : (
                                <div
                                    className={'record_label value'}>&nbsp;</div>
                            )
                          }
                        </div>

                      </ChartListContentTitles>
                      <ChartListContentMetadata>
                        <div>
                          <div className={'label'}>Plays</div>
                          <div
                              className={'plays value'}>{t.plays.toLocaleString(
                              'en-US')}</div>
                        </div>
                        <div>
                          <div className={'label'}>Duration (sec)</div>
                          <div
                              className={'duration value'}>{t.duration.toLocaleString(
                              'en-US')}</div>
                        </div>
                        <div>
                          <div className={'label'}>Original BPM</div>
                          <div className={'bpm value'}>{t.bpm ||
                              (<span>-</span>)}</div>
                        </div>
                      </ChartListContentMetadata>
                    </ChartListContentBodyArea>
                  </ChartListContentItem>
              );
            })
          }
        </ChartListContentItems>
      </ChartListContentWrap>
  );
}

function TheChartList({tracks}) {
  const {state} = useApp();
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [pages, setPages] = useState([]);

  useEffect(() => {
    setCurrentPageIndex(0);
    if (!tracks || !tracks.length) {
      setPages([]);
      return;
    }
    let _pages = [];
    let _page = [];

    if (state.chart_view.sort_by === 'default') {
      if (state.chart_view.sort_order === 'asc') {
        tracks.sort((a, b) => {
          return a.rank - b.rank;
        });
      } else {
        tracks.sort((a, b) => {
          return b.rank - a.rank;
        });
      }
    } else if (state.chart_view.sort_by === 'bpm') {
      if (state.chart_view.sort_order === 'asc') {
        tracks.sort((a, b) => {
          let aval = a.bpm || 100000 + a.rank;
          let bval = b.bpm || 100000 + b.rank;

          if (aval === bval) {
            return a.rank - b.rank;
          }
          return aval - bval;
        });
      } else {
        tracks.sort((a, b) => {
          if (a.bpm === b.bpm) {
            return a.rank - b.rank;
          }
          return b.bpm - a.bpm;
        });
      }
    }
    tracks.forEach((t, i) => {
      _page.push(t);
      if (_page.length >= state.chart_view.per_page) {
        _pages.push(_page);
        _page = [];
      }
    });
    if (_page.length) {
      _pages.push(_page);
    }
    setPages(_pages);
  }, [state.chart_view, tracks]);

  return (
      <ChartListWrap>
        <ChartListContent tracks={pages[currentPageIndex] || []}/>

        <ChartListFooter className={`${pages.length < 2 ? 'hidden' : ''}`}>
          <ChartListNavButton
              className={`prev ${currentPageIndex === 0
                  ? 'hidden'
                  : ''}`}
              onClick={() => {
                setCurrentPageIndex(Math.max(currentPageIndex - 1, 0));
              }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="11.375"
                 height="19.719" viewBox="0 0 11.375 19.719">
              <path
                  d="M9.859,0l1.516,1.516L3.031,9.859,11.375,18.2,9.859,19.718,0,9.859Z"
                  transform="translate(0 0)"/>
            </svg>
          </ChartListNavButton>

          <ChartListPageButtons>
            {
              pages.length > 3 && currentPageIndex > 1 ? (
                  <ChartListPageEllipsis className={'sp'}>
                    <span>…</span>
                  </ChartListPageEllipsis>
              ) : ''
            }
            {
              pages.map((p, i) => {

                return (
                    <ChartListPageButton
                        key={i}
                        className={`in_touch_target ${currentPageIndex === i
                            ? 'active'
                            : ''} ${(pages.length > 3 && currentPageIndex >
                            1 && i < pages.length - 3) ||
                        (pages.length > 3 && currentPageIndex < 2 && i > 2)
                            ? 'pc'
                            : ''}`}
                        onClick={() => {
                          setCurrentPageIndex(i);
                        }}
                    >
                      <span>{i + 1}</span>
                    </ChartListPageButton>
                );

              })
            }

            {
              pages.length > 3 && currentPageIndex < 2 ? (
                  <ChartListPageEllipsis className={'sp'}>
                    <span>…</span>
                  </ChartListPageEllipsis>
              ) : ''
            }

          </ChartListPageButtons>

          <ChartListNavButton
              className={`next ${currentPageIndex === pages.length - 1
                  ? 'hidden'
                  : ''}`}
              onClick={() => {
                setCurrentPageIndex(
                    Math.min(currentPageIndex + 1, pages.length - 1));
              }}

          >
            <svg xmlns="http://www.w3.org/2000/svg" width="11.375"
                 height="19.719" viewBox="0 0 11.375 19.719">
              <path
                  d="M1.515,0,0,1.515,8.344,9.859,0,18.2l1.516,1.516,9.859-9.859Z"
                  transform="translate(0 0)"/>
            </svg>
          </ChartListNavButton>
        </ChartListFooter>
      </ChartListWrap>
  );
}

function TheChart({data}) {
  const {state} = useApp();
  const [selectedRoomID, setSelectedRoomID] = useState(0);
  const [tracksData, setTracksData] = useState([]);

  useEffect(() => {
    if (!data || !data.some(d => d.id === selectedRoomID)) {
      setSelectedRoomID(0);
    }
  }, [data]);

  const onRoomSelected = (newRoomID) => {
    setSelectedRoomID(newRoomID);
  };

  useEffect(() => {
    let _data = (data || []).find(d => d.id === selectedRoomID);
    if (!_data) {
      setTracksData([]);
    } else {
      setTracksData(_data.tracks);
    }

  }, [data, selectedRoomID]);

  return (
      <>
        {data.length ? (
            <LatestChartElm id={'latest-chart'}>
              <LatestChartRoomSelector
                  onRoomSelected={onRoomSelected}
                  selectedRoomID={selectedRoomID}
                  rooms={data.length ? data.map(d => {

                    if (d.type === 'room') {
                      return {
                        id: d.id,
                        name: d.room.name || '',
                      };
                    } else if (d.type === 'device') {
                      return {
                        id: d.id,
                        name: d.device?.device_name || '',
                      };
                    } else {
                      return {
                        id: 0,
                        name: 'All',
                      };
                    }
                  }) : [
                    {
                      id: 0,
                      name: 'All',
                    }]}/>
              <ChartListHeaderWrap>
                <ChartListTitleWrap>
                  <ChartListTitle>Top 50 most played</ChartListTitle>
                  <ChartListSortCondition>{state.chart_view.sort_by ===
                  'default' ? '' : '[ ' + SORT_OPTIONS.find(
                          o => o.sort_order === state.chart_view.sort_order &&
                              o.sort_by ===
                              state.chart_view.sort_by).label +
                      ' ]'}</ChartListSortCondition>
                </ChartListTitleWrap>
                <CharListViewConfigWrap>
                  <CharListViewConfig onRoomSelected={onRoomSelected}/>
                </CharListViewConfigWrap>
              </ChartListHeaderWrap>
              <TheChartList tracks={tracksData}/>
            </LatestChartElm>
        ) : (
            <NoData/>
        )
        }
      </>
  );
}

const DisclaimerWrap = styled.div`
  margin-top: 20px;
  font-size: 14px;
  line-height: 19px;
`;

function PeriodSection() {
  const {state} = useApp();
  const [fetchedPeriod, setFetchedPeriod] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (fetchedPeriod &&
        data &&
        state.chart_period.from === fetchedPeriod.from &&
        state.chart_period.to === fetchedPeriod.to &&
        state.chart_period.category === fetchedPeriod.category) {
      return;
    }
    updateData(state.chart_period);
  }, [state.chart_period]);

  const updateData = async ({from, to, category}) => {
    let _data = await getVenueChart({
      from,
      to,
    });
    if (_data?.rooms) {
      _data.rooms.forEach(r => {
        (r.tracks || []).forEach((t, i) => {
          t.rank = i + 1;
        });
      });
    }
    setFetchedPeriod({
      from,
      to,
      category,
    });
    setData(_data);
  };

  if (!fetchedPeriod) {
    return '';
  }

  return (
      <PeriodSectionWrap>
        <ChartHeader>
          <CurrentPeriodArea>
            <LabelWithInfo
                text={'Chart'}
                style={{
                  marginTop: 30,
                  marginBottom: 10,
                }}
            >
              <div>
                Data updates may affect KUVO Charts, as more DJ music play data
                is processed.
              </div>
            </LabelWithInfo>
            <CurrentPeriod>
              <span>{moment(state.chart_period.from).
                  format('MMMM D, YYYY')}</span>
              <div className={'to'}/>
              <span>{moment(state.chart_period.to).
                  format('MMMM D, YYYY')}</span>
            </CurrentPeriod>
          </CurrentPeriodArea>
        </ChartHeader>
        <PeriodWrap id={'period-wrap'}>
          <PeriodSelectorArea>
            <ChartPeriodSelector/>
          </PeriodSelectorArea>
          <PeriodContents>
            <TheChart data={data?.rooms || []}/>
          </PeriodContents>
        </PeriodWrap>
        <DisclaimerWrap>Our charts are updated regularly to ensure you have
          access to the latest and most accurate data.</DisclaimerWrap>
      </PeriodSectionWrap>
  );
}

const ChartPeriodSelectorWrap = styled.div`
  pointer-events: initial;

  position: sticky;
  top: -1px;
  bottom: 300px;
  padding-top: 0px;
  z-index: 5;

  &.is-pinned {
    padding-top: 1px;
  }

  & > div {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    & > * {
      width: 25%;
      flex: 0 0 auto;
      height: 56px;

      @media ${config.layout.wide} {
        height: 44px;
      }
    }
  }
`;

const PeriodSelectorItemElm = styled.div`
  background-color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #000;
  cursor: pointer;
  border-bottom: 1px solid #000;

  &:first-child {
    border-left: 1px solid #000;
  }

  @media ${config.layout.wide} {
    transition: background-color 0.15s linear, color 0.15s linear;
  }

  span {
    color: #ffffff;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    line-height: 16px;
    
    pointer-events: none;
    @media ${config.layout.wide} {
      transition: background-color 0.15s linear, color 0.15s linear;
      font-size: 16px;
      font-weight: bold;
      line-height: 21px;
    }
  }

  position: relative;

  &::after {
    content: '';
    display: block;
    position: absolute;
    right: 0;
    top: 0px;
    bottom: 0px;
    width: 1px;
    background-color: #fff;
  }

  &::before {
    content: '';
    display: none;
    position: absolute;
    width: 10px;
    height: 10px;
    border-left: 1px solid #000;
    border-bottom: 1px solid #000;
    bottom: -6px;
    left: 50%;
    background-color: #fff;
    transform: translateX(-50%) rotateZ(-45deg);

    @media ${config.layout.wide} {
      width: 12px;
      height: 12px;
      bottom: -6.5px;
    }
  }

  &.selected {
    background-color: #ffffff;

    span {
      color: #000000;
    }

    &::after {
      background-color: #000;
    }

    &::before {
      display: block;

    }
  }

  &.in_touch {
    background-color: #ffffff;
    span {
      color: #000000;
    }
    &::after {
      background-color: #000;
    }
  }

  &:hover {
    @media ${config.layout.wide} {
      @media (hover: hover) {
        background-color: #ffffff;

        span {
          color: #000000;
        }

        &::after {
          background-color: #000;
        }
      }
    }
  }
`;

function PeriodSelectorItem({onClick, selected, children}) {
  return (
      <PeriodSelectorItemElm
          onClick={onClick}
          className={(selected ? 'selected' : '') + ' in_touch_target'}
      >
        {children}
      </PeriodSelectorItemElm>
  );
}

function ChartPeriodSelector() {
  const {state, dispatch} = useApp();
  const timer = useRef(null);

  const [tempPeriod, setTempPeriod] = useState(
      JSON.parse(JSON.stringify(state.chart_period)));

  const onSelectMonth = ({year, month}) => {
    let m = moment(new Date(year, month - 1, 1));
    let from = m.format('YYYY-MM-DD');
    m.endOf('month');
    let to = m.format('YYYY-MM-DD');
    if (new Date() < m.toDate()) {
      to = moment().add(-2, 'days').format('YYYY-MM-DD');
    }

    setTempPeriod({
      from,
      to,
      year,
      month,
      category: 'month',
    });
  };

  useEffect(() => {
    setTimeout(() => {
      try {
        const el = document.querySelector('#period-selector');
        const observer = new IntersectionObserver(
            ([e]) => e.target.classList.toggle('is-pinned',
                e.intersectionRatio < 1),
            {threshold: [1]},
        );
        if (el) {
          observer.observe(el);
        }
      } catch (e) {
        console.error(e);
      }
    }, 500);
  }, []);

  useEffect(() => {
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = null;
    }
    timer.current = setTimeout(updateCore, 500);

  }, [tempPeriod]);

  const updateCore = () => {
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = null;
    }
    dispatch({
      type: 'set_chart_period',
      chart_period: tempPeriod,
    });
  };

  return (
      <ChartPeriodSelectorWrap id={'period-selector'}>
        <div>
          <PeriodSelectorItem selected={tempPeriod.category === '7days'}
                              onClick={() => {
                                const m = moment();
                                m.add(-8, 'days');
                                m.startOf('day');
                                const from = m.format('YYYY-MM-DD');
                                m.add(6, 'days');
                                m.startOf('day');
                                const to = m.format('YYYY-MM-DD');
                                setTempPeriod({
                                  ...tempPeriod,
                                  from,
                                  to,
                                  category: '7days',
                                });
                              }}><span>Last <br
              className={'sp'}/>7 days</span></PeriodSelectorItem>
          <PeriodSelectorItem selected={tempPeriod.category === '14days'}
                              onClick={() => {
                                const m = moment();
                                m.add(-15, 'days');
                                m.startOf('day');
                                const from = m.format('YYYY-MM-DD');
                                m.add(13, 'days');
                                m.startOf('day');
                                const to = m.format('YYYY-MM-DD');
                                setTempPeriod({
                                  ...tempPeriod,
                                  from,
                                  to,
                                  category: '14days',
                                });
                              }}><span>Last <br
              className={'sp'}/>14 days</span></PeriodSelectorItem>
          <PeriodSelectorItem selected={tempPeriod.category === '30days'}
                              onClick={() => {
                                const m = moment();
                                m.add(-31, 'days');
                                m.startOf('day');
                                const from = m.format('YYYY-MM-DD');
                                m.add(29, 'days');
                                m.startOf('day');
                                const to = m.format('YYYY-MM-DD');
                                setTempPeriod({
                                  ...tempPeriod,
                                  from,
                                  to,
                                  category: '30days',
                                });
                              }}><span>Last <br
              className={'sp'}/>30 days</span></PeriodSelectorItem>
          <YearMonthSelect year={tempPeriod.year} month={tempPeriod.month}
                           onSelectMonth={onSelectMonth}
                           selected={tempPeriod.category === 'month'}/>
        </div>
      </ChartPeriodSelectorWrap>
  );
}

const PeriodSelectorArea = styled.div`
  height: calc(100% - 200px);
  position: absolute;
  top: 0;
  left: -20px;
  width: 100vw;
  pointer-events: none;

  @media ${config.layout.wide} {
    height: calc(100% - 300px);
    left: 0;
    width: 100%;
  }
`;

const PeriodSelectedLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #000000;
  border-bottom: 1px solid #000000;
  border-right: 1px solid #000000;
  height: 56px;
  line-height: 16px;
  font-size: 14px;
  font-weight: bold;
  cursor: default;
  position: relative;
  background-color: #000000;
  color: #ffffff;
  

  flex: 0 0 auto;
  width: 25%;

  @media ${config.layout.wide} {
    transition: background-color 0.15s linear, color 0.15s linear;
    height: 44px;
    font-size: 16px;
    line-height: 21px;
  }

  &::after {
    content: "";
    position: absolute;
    display: block;
    width: 10px;
    height: 8px;
    border-top: 2px solid #ffffff;
    border-bottom: 2px solid #ffffff;
    right: 10px;
    top: 50%;
    margin-top: -4px;

    @media ${config.layout.wide} {
      right: 20px;
    }
  }

  &::before {
    content: '';
    display: none;
    position: absolute;
    width: 10px;
    height: 10px;
    border-left: 1px solid #000;
    border-bottom: 1px solid #000;
    bottom: -6px;
    left: 50%;
    background-color: #fff;
    transform: translateX(-50%) rotateZ(-45deg);

    @media ${config.layout.wide} {
      width: 12px;
      height: 12px;
      bottom: -6.5px;
    }
  }

  &.selected {
    background-color: #ffffff;
    color: #000000;

    &::after {
      border-color: #000000;
    }

    &::before {
      display: block;
    }

  }

  span {
    margin-right: 13px;
    text-align: center;
    @media ${config.layout.wide} {
      margin-right: 5px;
    }
  }
  
  &.in_touch {
    background-color: #ffffff;
    color: #000000;

    &::after {
      border-color: #000000;
    }
  }

  @media ${config.layout.wide} {
    @media (hover: hover) {
      &:hover {
        background-color: #ffffff;
        color: #000000;

        &::after {
          border-color: #000000;
        }
      }
    }
  }

`;

function YearMonthSelect({year, month, onSelectMonth, selected}) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  let selectedIndex = selected ? (year ? CHART_MONTHS.findIndex(
      m => m.year === year && m.month === month) || 0 : 0) : -1;

  const onClick = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const itemSelect = (index) => {
    setModalIsOpen(false);
    onSelectMonth && onSelectMonth(CHART_MONTHS[index]);
  };

  const yLabel = selected ? (year === 0 ? '' : CHART_MONTHS[selectedIndex].label.split(
      ' ')[1]) : '';
  const mLabel = selected ? (year === 0 ? '' : CHART_MONTHS[selectedIndex].label.split(
      ' ')[0]) : '';

  return (
      <>
        <PeriodSelectedLabel onClick={onClick}
                             className={`reverse in_touch_target ${selected ? 'selected' : ''}`}
        >{!selected
            ? (<span>Select <br className={'sp'}/>month</span>)
            : (<span>{mLabel} <br className={'sp'}/>{yLabel}</span>)
        }</PeriodSelectedLabel>
        <SelectModal
            title="Select month"
            candidates={CHART_MONTHS.map(y => y.label)}
            selectedIndex={selectedIndex}
            closeModal={closeModal}
            modalIsOpen={modalIsOpen}
            itemSelect={itemSelect}
        />
      </>
  );
}

export default function ChartPage() {
  const app = useApp();
  useEffect(() => {
    app.showHeader();
    document.title = 'Chart';
  }, []);

  return (
      <Page>
        <PageMainTitle>
          <span>Chart</span>
          <PoweredBy>
            <div className={'label'}>Powered by</div>
            <Link to={'/care/about/'} style={{
              pointerEvents: 'none',
            }}></Link>
          </PoweredBy>
        </PageMainTitle>
        <PeriodSection/>
      </Page>
  );

}
